export const USER_INVITATION_STATUSES = [
  { id: 'PENDING', name: 'čaká na prijatie' },
  { id: 'ACCEPTED', name: 'prijatá' },
  { id: 'CANCELLED', name: 'zrušená' },
];
